import React from 'react';
import Base from './Base';

type ButtonProps = React.ComponentProps<typeof Base>;

const Error: React.FC<ButtonProps> = ({ className, ...rest }) => {
    const classes = ['btn--outline-error', className].filter(Boolean).join(' ');
    return <Base className={classes} {...rest} />;
};

export default Error;
